import React, { useState, useEffect } from 'react';
import { Table, Tooltip, Button, Row, Col, Alert, Tag, Modal, Upload, message, Popconfirm } from 'antd';
import { UploadOutlined, EyeOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import { State, States } from 'sigt';
import { useWindowDimensions } from '../../utils/hooks';
import { ColumnsType } from 'antd/lib/table';
import _ from 'lodash';
import { createFile } from '../../redux/actions/taxes';
import fileImage from '../../assets/images/file.png';
import axios from 'axios';
import DisplayDoc from '../../components/DisplayDoc';
const server = process.env.REACT_APP_SERVER_URL;

const TableRIM: React.FC<PropsTableRIM> = ({ thm, tax, auth, createFile, preloadedData, idRim, onSuccess, readOnly }) => {
  const [loading, setLoading] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState<any>(null);

  const [fileList, setFileList] = useState<any[]>([]);
  const [uploading, setUploading] = useState(false);
  const [preview, setPreview] = useState({ visible: false, url: '', title: '' });

  const getState = (estado) => {
    if (!estado) return { name: 'No verificado', color: 'warning' };
    return { name: 'Verificado', color: 'green' };
  };

  const showModal = (record: any) => {
    setSelectedDoc(record);
    setIsModalVisible(true);
  };

  const tiposDocumentos = [
    { id: 1, nombre: 'RIF Vigente', obligatorio: true, estado: 'verificado' },
    { id: 2, nombre: 'Cédula del Representante Legal', obligatorio: true, estado: 'verificado' },
    { id: 3, nombre: 'Documento de Acta Constitutiva', obligatorio: true, estado: 'verificado' },
    { id: 4, nombre: 'Documento de Última Asamblea', obligatorio: true, estado: 'verificado' },
    { id: 5, nombre: 'Ficha Catastral', obligatorio: true, estado: 'verificado' },
    { id: 6, nombre: 'Conformidad de Uso', obligatorio: true, estado: 'verificado' },
    { id: 7, nombre: 'Permiso de Ingeniería Municipal', obligatorio: false, estado: 'verificado' },
    { id: 8, nombre: 'Permiso de Bomberos', obligatorio: true, estado: null },
  ];

  const data: any[] = [];
  const filterStatus: any[] = [];
  const tx = preloadedData || tiposDocumentos;
  tx.forEach((ele) => {
    const state = getState(ele.estado);
    data.push({ ...ele, state });
    if (typeof _.find(filterStatus, (e) => e.value === state.name) !== 'object')
      filterStatus.push({ value: state.name, text: state.name });
  });

  useEffect(() => {
    setLoading(false);
  }, [data]);

  const handleOpenPreview = (url: string, title: string) => {
    setPreview({ visible: true, url, title });
  };

  const handleClosePreview = () => {
    setPreview({ visible: false, url: '', title: '' });
  };

  const handleDelete = async (id: number) => {
    try {
      const response = await axios.delete(`${server}/uploads/documentosRIM/${id}`, {
        headers: { Authorization: `Bearer ${auth.token}` },
      });

      if (response.status === 200) {
        message.success('Documento eliminado correctamente');
        setIsModalVisible(false);

        if (onSuccess) {
          onSuccess();
        }
      }
    } catch (error) {
      console.error(error);
      message.error('No se pudo eliminar el documento');
    } 
  };

  const renderAction = (record: DocumentoRow) => {
    const isUploaded = record.estado !== null;

    return (
      <Row justify='center' gutter={8}>
        {!isUploaded ? (
          <Col>
            <Button type='primary' icon={<UploadOutlined />} size='small' onClick={() => showModal(record)}>
              Cargar
            </Button>
          </Col>
        ) : (
          <>
            <Col>
              <Tooltip title='Ver'>
                <Button
                  type='primary'
                  shape={readOnly ? undefined : 'circle'}
                  icon={<EyeOutlined />}
                  size={readOnly ? 'large' : 'small'}
                  onClick={() => handleOpenPreview(record.url || '', record.nombre || '')}
                >
                  {readOnly && 'Ver'}
                </Button>
              </Tooltip>
            </Col>
            {!readOnly && (
              <Col>
                <Tooltip title='Editar'>
                  <Button
                    shape='circle'
                    icon={<EditOutlined />}
                    size='small'
                    onClick={() => {
                      setSelectedDoc(record);
                      setIsModalVisible(true);
                    }}
                  />
                </Tooltip>
              </Col>
            )}
            {!readOnly && (
              <Col>
                <Tooltip title='Eliminar'>
                  <Popconfirm
                    title='¿Estás seguro de eliminar este documento? Esta acción no se puede deshacer.'
                    onConfirm={() => handleDelete(record.id_recaudo_rim)}
                    okText='Sí, eliminar'
                    cancelText='No'
                    okButtonProps={{ danger: true}}
                  >
                    <Button danger shape='circle' icon={<DeleteOutlined />} size='small' />
                  </Popconfirm>
                </Tooltip>
              </Col>
            )}
          </>
        )}
      </Row>
    );
  };

  const columns: ColumnsType<any> = [
    {
      title: 'Tipo',

      ellipsis: true,
      width: '50%',

      dataIndex: 'nombre',
      render: (text, record) => (
      <span>
        {text} 
        {!record.obligatorio && (
          <span style={{ 
            color: '#8c8c8c', 
            fontSize: '12px', 
            fontStyle: 'italic',
            marginLeft: '8px' 
          }}>
            (si aplica)
          </span>
        )}
      </span>
    ),
    },
    {
      title: 'Estado',
      dataIndex: 'state',
      align: 'center',
      filters: filterStatus,
      onFilter: (value, record) => record.state.name.toLowerCase().indexOf((value as string).toLowerCase()) === 0,
      render: (value, record) => (
        <Tag style={{ width: '100%', textAlign: 'center' }} color={getState(record.estado).color}>
          {getState(record.estado).name}
        </Tag>
      ),
    },
    {
      title: '',
      key: 'action',
      render: (_, record) => renderAction(record),
    },
  ];

  const columnsRead: ColumnsType<any> = [
    {
      title: 'Tipo',

      ellipsis: true,
      width: '60%',

      dataIndex: 'nombre',
    },
    {
      title: '',
      key: 'action',
      render: (_, record) => renderAction(record),
    },
  ];

  const handleSaveModal = async () => {
    if (fileList.length === 0) {
      message.warning('Por favor, selecciona un documento antes de guardar.');
      return;
    }

    const fd = new FormData();
    fd.append('documentosRIM', fileList[0]);
    fd.append('id_registro_municipal', idRim?.toString() || '');
    fd.append('tipo_recaudo', selectedDoc?.id.toString());

    try {
      setUploading(true);

      const isEditing = !!selectedDoc.url;

      if (!isEditing) {
        // Agregar Documento
        const response = await axios.post(`${server}/uploads/documentosRIM/${idRim}`, fd, {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        });

        if (response.status === 201 || response.status === 200) {
          message.success('Documento registrado correctamente.');

          setFileList([]);
        }
      } else {
        // Editar Documento
        fd.append('id_recaudo_rim', selectedDoc.id_recaudo_rim);
        const response = await axios.put(`${server}/uploads/documentosRIM/${idRim}`, fd, {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        });
        if (response.status === 201 || response.status === 200) {
          message.success('Documento editado correctamente.');
          setFileList([]);
          setSelectedDoc(null);
        }
      }
      setIsModalVisible(false);

      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      console.error('Error al guardar el documento:', error);
      message.error('Hubo un error al guardar el documento.');
    } finally {
      setUploading(false);
    }
  };

  const handleCancelModal = () => {
    setIsModalVisible(false);
    setSelectedDoc(null);
  };

  return (
    <>
      <Table
        style={{ height: '100%' }}
        size='middle'
        pagination={false}
        loading={loading}
        columns={readOnly ? columnsRead : columns}
        dataSource={data}
        rowKey={(e) => e.id_recaudo_rim || e.tipo_recaudo}
        bordered={!!preloadedData}
      />
      <Modal
        title={`Cargar: ${selectedDoc?.nombre}`}
        visible={isModalVisible}
        onOk={handleSaveModal}
        onCancel={handleCancelModal}
        okText='Guardar'
        okButtonProps={{
          loading: uploading,
        }}
        cancelText='Cancelar'
        destroyOnClose
        afterClose={() => {
          setFileList([]);
          setSelectedDoc(null);
        }}
        confirmLoading={uploading}
        maskClosable={!uploading}
        keyboard={!uploading}
        cancelButtonProps={{ disabled: uploading }}
        closable={!uploading}
      >
        <p>
          Seleccione el archivo para el documento <b>{selectedDoc?.nombre}</b>
        </p>

        {selectedDoc?.url && (
          <Alert
            message='Este documento ya tiene un archivo cargado. Al subir uno nuevo, el anterior será eliminado permanentemente.'
            type='warning'
            showIcon
            style={{ marginBottom: 16 }}
          />
        )}

        <Upload.Dragger
          name='file'
          multiple={false}
          accept='.pdf, image/*'
          fileList={fileList}
          beforeUpload={(file) => {
            const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
            const isAllowed = allowedTypes.includes(file.type);

            if (!isAllowed) {
              message.error(`${file.name} no es un archivo PDF o imagen válida.`);
              return false;
            }
            setFileList([file]);
            return false;
          }}
          onRemove={() => {
            setFileList([]);
          }}
        >
          <p className='ant-upload-drag-icon'>
            <img src={fileImage} alt='pdfIcon' style={{ width: 100 }} />
          </p>
          <p className='ant-upload-text'>Haga clic o arrastre el archivo a esta área para subir el archivo</p>
          <p className='ant-upload-hint'>Soporta un solo archivo PDF o Imagen.</p>
        </Upload.Dragger>
      </Modal>

      <Modal
        title={preview.title || 'Vista Previa del Documento'}
        visible={preview.visible}
        onCancel={handleClosePreview}
        footer={null}
        width={1000}
        centered
        destroyOnClose
      >
        <DisplayDoc url={preview.url} expand={false} />
      </Modal>
    </>
  );
};
const mapStateToProps = ({ tax, thm, auth }: State) => ({ tax, thm, auth });

export default connect(mapStateToProps, { createFile })(TableRIM);

interface PropsTableRIM {
  tax: States.Taxes;
  thm: States.ThemeColors;
  auth: States.Auth;
  createFile: (id: number, tipoCertificado: string, token: string) => Promise<void>;
  preloadedData?: any;
  idRim?: number;
  onSuccess?: () => void;
  readOnly?: boolean;
}

interface DocumentoRow {
  id: number;
  nombre: string;
  obligatorio: boolean;
  estado: string | null;
  url: string | null;
  id_recaudo_rim: number;
  state: {
    name: string;
    color: string;
  };
}
